import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { SurveyComponent } from "./survey.component";
import { SurveyFormComponent } from "./survey-form/survey-form.component";
import { SurveyQuestionComponent } from "./survey-form/survey-question/survey-question.component";
import { UserTypeSurveyComponent } from "./user-type-survey/user-type-survey.component";

const routes: Routes = [
  {
    path: "", component: SurveyComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SurveyRoutingModule {
  static components = [
    SurveyComponent,
    SurveyFormComponent,
    SurveyQuestionComponent,
  ];
}
